/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ratelimit_Title1Inputs */

const he_ratelimit_title1 = /** @type {(inputs: Ratelimit_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`רגע, מהיר מדי!`)
};

const en_ratelimit_title1 = /** @type {(inputs: Ratelimit_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Whoa there, speedster!`)
};

/**
* | output |
* | --- |
* | "Whoa there, speedster!" |
*
* @param {Ratelimit_Title1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const ratelimit_title1 = /** @type {((inputs?: Ratelimit_Title1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ratelimit_Title1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_ratelimit_title1(inputs)
	return en_ratelimit_title1(inputs)
});
export { ratelimit_title1 as "rateLimit_title" }